module.exports = __webpack_public_path__ + "img/cellTeam_offline.aa184c82.png";